import { useEffect } from 'react';
import { selectCurrentZoomLevel } from '../../reducers/zoomSlice';
import { SCROLL_CONTAINERS_EVENT } from '../constants';
import { useAppSelector } from '../../reducers/rootReducer';

const usePanUpdate = (handlePanUpdate: (newPan: number) => void): void => {
  const currentZoomLevel = useAppSelector(selectCurrentZoomLevel);

  useEffect(() => {
    document.addEventListener(SCROLL_CONTAINERS_EVENT, handleEvent);

    return () => {
      document.removeEventListener(SCROLL_CONTAINERS_EVENT, handleEvent);
    };
  }, [currentZoomLevel]);

  const handleEvent = (e) => {
    const newPan = e.detail;
    handlePanUpdate(newPan);
  };
};

export const scrollAllSubscribedContainers = (panToScrollTo) => {
  const event = new CustomEvent(SCROLL_CONTAINERS_EVENT, {
    detail: panToScrollTo,
  });
  document.dispatchEvent(event);
};

export default usePanUpdate;
